module.exports = __webpack_public_path__ + "images/emails/digest/clipboard-b-265222d6.png";